<script>
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';

import BuyerInput from './BuyerInput';

export default {
  components: {
    BuyerInput,
  },
  props: {
    open: Boolean,
    links: Array,
    userLoggedIn: Boolean,
    search: String,
    isWhitelabel: Boolean,
  },
  data: () => ({
    isNull,
    isUndefined,
  }),
  methods: {
    clickLink(link) {
      this.closeMenu();

      if (link.uri === 'action') {
        this.$emit(link.actionName, link.actionArgs);
      }
    },
    closeMenu() {
      this.$emit('close-menu');
    },
    performSearch(e) {
      if (e.target.value) {
        this.closeMenu();
      }

      this.$emit('perform-search', e)
    },
    beforeEnter(el) {
      el.style.height = 0;
    },
    enter(el, done) {
      el.style.height = `${el.scrollHeight + 1}px`;

      done();
    },
    clickSubMenuLink(link) {
      this.closeMenu();

      link.subMenuOpen = false;
    },
    subMenuUri(subMenuLink) {
      return this.isWhitelabel ? { name: 'collection', params: { collectionSlug: subMenuLink.value, page: '1' } } : { name: 'marketplace', query: { category: subMenuLink.value }, params: { nav: true } };
    },
  },
};
</script>

<template lang='pug'>
transition(name='menu')
  .flex.fixed.top-0.left-0.h-full.md_hidden.w-full.z-300(v-if='open', v-touch:swipe.left='closeMenu')
    .menu-content.bg-brand.w-11-12.h-full.flex.flex-col.justify-between.px-3.pt-3.pb-1.relative

      svg.text-white.h-2.absolute.right-1.top-1(
        tabindex='0',
        viewBox='0 0 24 24',
        @click='closeMenu',
        @keyup.enter='closeMenu',
      )
        path.fill-current(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')

      .overflow-y-auto
        buyer-input.my-1(
          white,
          placeholder='Search',
          type='search',
          :value='search',
          @input='$emit("search-input", $event)',
          @search='performSearch',
        )

        template(v-for='link in links')

          .h-px.bg-white.w-full.opacity-50.my-1(v-if='link.break')

          .text-white.text-2xl.leading-loose.my-1(
            v-else-if='(isNull(link.showWhenUserLoggedIn) || isUndefined(link.showWhenUserLoggedIn)) || \
              (link.showWhenUserLoggedIn && userLoggedIn) || \
              (!link.showWhenUserLoggedIn && !userLoggedIn)',
          )

            template(v-if='link.subMenu')
              .flex.justify-between.items-center(
                tabindex='0',
                @click='link.subMenuOpen = !link.subMenuOpen',
                @keyup.enter='link.subMenuOpen = !link.subMenuOpen',
              )
                span {{link.text}}
                svg(v-if='link.subMenuOpen', style='width:24px;height:24px', viewBox='0 0 24 24')
                  path.fill-current(d='M19,13H5V11H19V13Z')
                svg(v-else, style='width:24px;height:24px', viewBox='0 0 24 24')
                  path.fill-current(d='M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z')
              transition(
                @before-enter='beforeEnter',
                @enter='enter',
                @leave='beforeEnter',
              )
                .transition-250.transition-all.overflow-hidden(v-if='link.subMenuOpen')
                  .text-white.text-xl.leading-loose.my-1.ml-1(v-for='subMenuLink in link.subMenu')
                    router-link(
                      tabindex='0',
                      tag='span',
                      :to='subMenuUri(subMenuLink)',
                      @click.native='clickSubMenuLink(link)',
                      @keyup.enter.native='clickSubMenuLink(link)',
                    ) {{subMenuLink.text}}

            template(v-else)
              span(
                v-if='link.uri === "action"',
                tabindex='0',
                @click='clickLink(link)',
                @keyup.enter='clickLink(link)',
              ) {{link.text}}
              router-link(
                v-else,
                tag='span',
                tabindex='0',
                :to='link.uri',
                @click.native='closeMenu',
                @keyup.enter.native='closeMenu',
              ) {{link.text}}

      slot
    .menu-block.w-1-12.h-full(@click='closeMenu')
</template>

<style>
@import '~import/index';

.menu {
  &-content {
    box-shadow: 6px 5px 14px rgba(0, 0, 0, 0.23);
  }

  &-block {
    transition: opacity 250ms 250ms;
    background-color: rgba(0, 0, 0, 0.4);
  }

  &-enter,
  &-leave-to {
    .menu-content {
      transform: translateX(-100%);
    }

    .menu-block {
      opacity: 0;
    }
  }

  &-leave,
  &-enter-to {
    .menu-content {
      transform: translateX(0);
    }

    .menu-block {
      opacity: 100;
    }
  }

  &-enter-active,
  &-leave-active {
    /* I guess Vue needs this for the timing even though it does not do anything CSS wise */
    transition: transform 250ms;

    .menu-content {
      transition: transform 250ms;
    }
  }

  &-leave-active {
    .menu-block {
      transition: none;
    }
  }
}
</style>